
'use client';

// Barrel: re-exports the Firebase client provider, error plumbing, and the
// Firestore hooks (use-collection / use-doc / use-user-by-*). The actual SDK
// initialization lives in `firebase/client.ts`.

export * from './provider';
export * from './client-provider';
export * from './firestore/use-collection';
export * from './firestore/use-doc';
export * from './firestore/use-user-by-username';
export * from './firestore/use-user-by-id';
export * from './errors';
export * from './error-emitter';

// Re-export useUser separately to avoid naming conflicts if you have other 'useUser' hooks.
export { useUser } from './provider';
